var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._b({staticClass:"btn",class:[
    _vm.$attrs.class,
    ("btn-" + _vm.variant),
    ("btn-" + _vm.size),
    { outlined: _vm.outlined, active: _vm.active, text: _vm.text } ],attrs:{"disabled":_vm.disabled,"loading":_vm.loading},on:{"click":_vm.handleClick}},'button',_vm.$attrs,false),[(_vm.icon)?_c('x-icon',_vm._b({attrs:{"size":"small"}},'x-icon',_vm.icon,false)):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }